import React from 'react';
import { AlertCircle, CheckCircle, X } from 'lucide-react';

const Toast = ({ message, type, onClose }) => {
  if (!message) return null;

  return (
    <div className="toast-notification" style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      backgroundColor: type === 'error' ? '#dc3545' : '#28a745',
      color: 'white',
      padding: '12px 20px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      zIndex: '9999',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      minWidth: '300px',
      maxWidth: '400px',
      animation: 'slideInRight 0.3s ease-out',
      fontSize: '14px'
    }}>
      {type === 'error' ? <AlertCircle size={18} /> : <CheckCircle size={18} />}
      <span style={{ flex: 1 }}>{message}</span>
      <button 
        onClick={onClose}
        style={{
          background: 'none',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          padding: '0',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default Toast;
